import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useMemo } from "react";
import { connect } from "react-redux";
import EmployeeCharts from "./EmployeeCharts";
import PayrollCharts from "./PayrollCharts";
import BusinessesCharts from "./BusinessesCharts";

const StatsCharts = ({ stats, currency, section }) => {
	const periods = useMemo(() => stats.map((entry) => entry.period));

	if (!stats) return null;

	return (
		<>
			<div className="form-grid col-3 col-xs-12 p-0">
				{section == "people" && (
					<EmployeeCharts
						stats={stats}
						currency={currency}
						periods={periods}
					/>
				)}
				{section == "payrolls" && (
					<PayrollCharts
						stats={stats}
						currency={currency}
						periods={periods}
					/>
				)}
				{section == "businesses" && (
					<BusinessesCharts
						stats={stats}
						currency={currency}
						periods={periods}
					/>
				)}
			</div>
		</>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StatsCharts);
